module.exports = __webpack_public_path__ + "img/p2-81.6551a55d.png";